var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable, Inject } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { DOCUMENT } from '@angular/common';
var StartupService = /** @class */ (function () {
    function StartupService(document) {
        this.document = document;
        // this.domain = 'https://app.deliforce.io/login';
        // this.domain = 'https://app.ciao-delivery.com/'
        // this.domain = 'https://app.xquara.co/login';
        // this.domain = 'https://www.vein-fast.com/login';
        // this.domain = 'https://miles.tiniva.com/login';
        // this.domain = 'http://0.0.0.0:4200 ';
        // this.domain = 'https://cargo.n2l.com/';
        this.domain = window.location.href.replace(/(https?:\/\/)?(www.)?/i, '');
        this.domainName = this.domain.split('.');
        if (this.domainName[1] === 'xquara') {
            this.loginIcon = 'https://resellersdelif.deliforce.io/xquara/loginIcon.png';
            this.navIcon = 'https://resellersdelif.deliforce.io/xquara/navigationIcon-white.png';
        }
        else if (this.domainName[1] === "vein-fast") {
            // this.loginIcon = 'https://resellersdelif.deliforce.io/veinfast/logo-brand.png';
            // this.navIcon = 'https://resellersdelif.deliforce.io/veinfast/logo-dashboar.png';
            this.loginIcon = 'https://resellersdelif.deliforce.io/veinfast/connekkt-brand-logo.png';
            this.navIcon = 'https://resellersdelif.deliforce.io/veinfast/connekkt-dashboard-logo.png';
        }
        else if (this.domainName[1] === "ciao-delivery") {
            this.loginIcon = 'https://resellersdelif.deliforce.io/ciao/Group+3984.svg';
            // this.loginIcon = 'https://deliforce-resellers.s3.ap-south-1.amazonaws.com/ciao/Group+3984.png';
            // this.loginIcon = 'https://deliforce-resellers.s3.ap-south-1.amazonaws.com/ciao/brand-logo-new.png';
            // this.loginIcon = 'https://deliforce-resellers.s3.ap-south-1.amazonaws.com/ciao/brand_logo.png';
            // this.loginIcon = 'https://deliforce-resellers.s3.ap-south-1.amazonaws.com/ciao/brand-logo.png';
            this.navIcon = 'https://resellersdelif.deliforce.io/ciao/title_icons.png';
        }
        else if (this.domainName[1] === "tiniva") {
            this.loginIcon = 'https://resellersdelif.deliforce.io/tiniva/brand_logo.png';
            this.navIcon = 'https://resellersdelif.deliforce.io/tiniva/dashboard_logo.png';
        }
        else if (this.domainName[1] === "n2l") {
            this.loginIcon = 'https://resellersdelif.deliforce.io/tiniva/n2l_logo-login.png';
            this.navIcon = 'https://resellersdelif.deliforce.io/tiniva/n2l_dashboard_logo2.png';
        }
        else {
            this.loginIcon = 'https://trackingdf.deliforce.io/brand.png';
            this.navIcon = 'https://trackingdf.deliforce.io/title_icon.png';
        }
    }
    // This is the method you want to call at bootstrap
    // Important: It should return a Promise
    StartupService.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this._startupData = this.domain;
                try {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var head = document.querySelector('head');
                            var title = document.querySelector('title');
                            var favicon = _this.document.createElement('link');
                            if (_this.domainName[1] === 'xquara') {
                                // console.log('xquara');
                                title.setAttribute('title', 'Xquara');
                                title.innerHTML = 'Xquara - Best last mile delivery tracking and Fieldforce management software';
                                favicon.setAttribute('rel', 'icon');
                                favicon.setAttribute('type', 'image/x-icon');
                                favicon.setAttribute('href', _this.navIcon);
                                head.appendChild(favicon);
                                resolve();
                            }
                            else if (_this.domainName[1] === 'vein-fast') {
                                // console.log('vein-fast');
                                // title.setAttribute('title', 'Vein-Fast');
                                // title.innerHTML = 'Vein-Fast - Best last mile delivery tracking and Fieldforce management software';
                                title.setAttribute('title', 'Connekkt');
                                title.innerHTML = 'Connekkt - Best last mile delivery tracking and Fieldforce management software';
                                favicon.setAttribute('rel', 'icon');
                                favicon.setAttribute('type', 'image/x-icon');
                                favicon.setAttribute('href', _this.navIcon);
                                head.appendChild(favicon);
                                resolve();
                            }
                            else if (_this.domainName[1] === 'ciao-delivery') {
                                // console.log('ciao');
                                title.setAttribute('title', 'Ciao-Delivery');
                                title.innerHTML = 'Ciao-Delivery - Best last mile delivery tracking and Fieldforce management software';
                                favicon.setAttribute('rel', 'icon');
                                favicon.setAttribute('type', 'image/x-icon');
                                favicon.setAttribute('href', _this.navIcon);
                                head.appendChild(favicon);
                                resolve();
                            }
                            else if (_this.domainName[1] === 'tiniva') {
                                // console.log('vein-fast');
                                title.setAttribute('title', 'Tiniva');
                                title.innerHTML = 'Tiniva - Best last mile delivery tracking and Fieldforce management software';
                                favicon.setAttribute('rel', 'icon');
                                favicon.setAttribute('type', 'image/x-icon');
                                favicon.setAttribute('href', _this.navIcon);
                                head.appendChild(favicon);
                                resolve();
                            }
                            else if (_this.domainName[1] === 'n2l') {
                                // console.log('vein-fast');
                                title.setAttribute('title', 'n2l');
                                title.innerHTML = 'n2l - Best last mile delivery tracking and Fieldforce management software';
                                favicon.setAttribute('rel', 'icon');
                                favicon.setAttribute('type', 'image/x-icon');
                                favicon.setAttribute('href', _this.navIcon);
                                head.appendChild(favicon);
                                resolve();
                            }
                            else {
                                // console.log('deliforce');
                                title.setAttribute('title', 'test');
                                title.innerHTML = 'Deliforce - Best last mile delivery tracking and Fieldforce management software';
                                // console.log(title);
                                favicon.setAttribute('rel', 'icon');
                                favicon.setAttribute('type', 'image/x-icon');
                                favicon.setAttribute('href', _this.navIcon);
                                head.appendChild(favicon);
                                resolve();
                            }
                        })];
                }
                catch (err) {
                    Promise.resolve(true);
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(StartupService.prototype, "startupData", {
        get: function () {
            return this._startupData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StartupService.prototype, "reseller", {
        get: function () {
            return this.domainName[1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StartupService.prototype, "lIcon", {
        get: function () {
            return this.loginIcon;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StartupService.prototype, "nIcon", {
        get: function () {
            return this.navIcon;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StartupService.prototype, "isReseller", {
        get: function () {
            if (this.domainName[1] != 'deliforce') {
                return true;
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StartupService.prototype, "loginText", {
        get: function () {
            if (this.domainName[1] === 'deliforce') {
                return 'Login in to Deliforce';
            }
            else if (this.domainName[1] === 'zquara') {
                return 'Login in to Xquara';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StartupService.prototype, "NewText", {
        get: function () {
            if (this.domainName[1] === 'deliforce') {
                return 'New to Deliforce';
            }
            else if (this.domainName[1] === 'zquara') {
                return 'New to Xquara';
            }
        },
        enumerable: true,
        configurable: true
    });
    StartupService = __decorate([
        Injectable(),
        __param(0, Inject(DOCUMENT)),
        __metadata("design:paramtypes", [HTMLDocument])
    ], StartupService);
    return StartupService;
}());
export { StartupService };



//////////////////
// WEBPACK FOOTER
// ./src/app/common/startup.service.ts
// module id = ./src/app/common/startup.service.ts
// module chunks = main